module.exports = __webpack_public_path__ + "img/heart_19_bj.9c61b3fc.png";